<template>
    <nav aria-label="Page navigation example" class="d-inline-block">
        <ul class="pagination pagination-dark">
            <li :class="'page-item ' + (current <= 1 ? 'disabled' : '')">
                <button class="page-link" :href="'#'" v-on:click='prevPage(current - 1)'>
                    Previous</button>
            </li>
            <li class="page-item" 
                v-for="i in total" 
                :key='i' 
                :class="current == i ? 'active': ''"
            >
                <button class="page-link" href="#" @click="onPage(i)" >{{ i }}</button>
            </li>
            <li :class="'page-item ' + (current >= total ? 'disabled' : '')">
                <button class="page-link" :href="'#'" v-on:click='nextPage(current + 1)'>
                    Next</button>
            </li>
        </ul>
    </nav>
</template>


<script>
/* 
    Props:
    
    @events like nextPage, prevPage, onPage
    return a method with acceptence of page paramater i.e
    click() {
        return (page=1) => {
            // your request here
        }
    }
*/
export default {
    props: ['current', 'total', 'nextPage', 'prevPage', 'onPage'],
    name: 'Pagination'
}
</script>


<style lang="scss">
.pagination-dark .page-link {
    background: #151515;
    border-color: #171717;
    border-style: inset;
    color: white;
    font-size: 13px;
}

.pagination-dark .active .page-link {
    background: #c8312b;
    border-color: #86100b;
}

.pagination-dark .disabled .page-link {
    background: #292929;
    border-color: black;
}

.pagination-dark .page-link:hover {
    background: #c8312b;
}
</style>